<template>
	<div class="content-container">
		<div class="content">
            <div class="container">

                <!-- Loading details -->
                <empty-state
                    v-show="landingPageLoaded === false && referencePresent === true"
                    statusIcon="loading"
                    title="We're just retrieving your details"
                    subtitle="Please wait a moment">
                </empty-state>

                <div class="row" v-if="landingPageLoaded === true || referencePresent === false">
                    <div class="col-12">

                        <!-- Invalid/Missing reference -->
                        <div class="card card-body" v-if="referencePresent === false || landingPageLoadSuccess === false">
                            <empty-state
                                statusIcon="error"
                                :title="this.invalidReferenceErrorHeader"
                                :subtitle="this.invalidReferenceError"
                            ></empty-state>
                        </div>

                        <!-- Ready to book -->
                        <template v-if="referencePresent === true && landingPageLoadSuccess === true">
                            <div class="title">
                                <h1>You're ready to book your doorstop repair!</h1>
                            </div>
                            <div class="card">
                                <div class="card-header">
                                    <h4>Booking details</h4>
                                </div>
                                <div class="card-body pb-2">
                                    <dl>
                                        <dt>Name</dt>
                                        <dd>{{ booking.first_name }} {{ booking.last_name }}</dd>
                                    </dl>
                                    <dl>
                                        <dt>Repair location</dt>
                                        <dd>{{ parseAddressToString(booking.address) }}</dd>
                                    </dl>

                                    <dl>
                                        <dt>Device</dt>
                                        <dd v-for="(device, key) in devices" :key="key">
                                            {{ device.device.model_title }}
                                        </dd>
                                    </dl>
                                </div>
                            </div>
                        </template>
                    </div>
                </div>
			</div>
            <!-- Footer -->
            <footer class="footer fixed-footer" v-if="landingPageLoaded === true && referencePresent === true && landingPageLoadSuccess === true">
                <div class="container">
                    <router-link :to="{ name: 'deviceColour'}" class="btn btn-lg continue-btn icon-right ml-auto">Select Device Colour <i class="fa fa-chevron-right ml-3 text-sm"></i></router-link>
                </div>
            </footer>
        </div>
    </div>
</template>

<script>
    import router from "@/router";

    import {mapActions, mapGetters} from "vuex";

    export default {
        name: 'PartnerRepairHome',

        mounted() {
            this.getBooking();
            if (this.redirectOnMissingReference) {
                this.invalidReferenceError = "We are returning you to " + this.carrierDetails.formattedName + " to re-start the booking process";
            } else {
                this.invalidReferenceError = "Please return to " + this.carrierDetails.formattedName + " and re-start the booking process";
            }
            if (this.carrierDetails.externalRedirectMessage !== undefined && this.carrierDetails.externalRedirectMessage.length > 0) {
                this.invalidReferenceError = this.carrierDetails.externalRedirectMessage;
            }
            if (this.carrierDetails.externalRedirectHeader !== undefined && this.carrierDetails.externalRedirectHeader.length > 0) {
              this.invalidReferenceErrorHeader = this.carrierDetails.externalRedirectHeader;
            } else {
              this.invalidReferenceErrorHeader = "Your booking reference is " + this.referenceErrorType;
            }
        },

        data() {
            return {
                referencePresent: true,
                invalidReferenceError: "",
                invalidReferenceErrorHeader: "",
            }
        },
        created() {
            this.$store.subscribe(((state) => {
                // Subscribe to state changes, so that we can react in a timely fashion rather than guessing at api responses
                if (state.type === 'SET_LANDING_PAGE_LOADED_SUCCESS' && state.payload === false) {
                    this.timedRedirect();
                }
            }))
        },

        computed: {
            ...mapGetters([
                'booking',
                'carrierDetails',
                'devices',
                'parseAddressToString',
                'landingPageLoaded',
                'landingPageLoadSuccess',
                'redirectOnMissingReference',
                'wasBookedInStore'
            ]),

            referenceErrorType() {
                return (this.referencePresent === true && this.landingPageLoadSuccess === false) ? "invalid" : "missing";
            }
        },

        methods: {
            ...mapActions([
                'getBookingByReference',
                'setStore'
            ]),

            getBooking() {
                if (router.currentRoute.query.ref && router.currentRoute.query.ref.length > 0) {
                    this.getBookingByReference(router.currentRoute.query.ref).then(() => {
                        if(this.booking.store_code) {
                            this.setStore(this.booking.store_code);
                        }
                    });
                } else {
                    this.referencePresent = false;
                    this.timedRedirect();
                }
            },
            timedRedirect() {
                if (this.redirectOnMissingReference && this.carrierDetails.externalRedirectUrl.length > 0) {
                    setTimeout(() => {
                        window.location = this.carrierDetails.externalRedirectUrl;
                    }, 6000);
                }
            },
            nextPage() {
                // @TODO: Update with logic to pull through the correct next page, WEF-362.
                this.$router.push({name: 'deviceColour'});
            }
        }
    }
</script>